import { AudienceCheck, AudienceName } from 'common/lib/experiments/types';
import { State } from 'modules';
import {
  ChannelModel,
  ExperimentDetailsObject,
  MemberModel,
  TestModel,
  Variation,
} from 'types';
import experiment from 'util/experiments';
import { getMe } from './members';

export const getMyChannels = (state: State): ChannelModel[] => {
  const CHANNELS = ['stable', 'beta', 'alpha'];
  const { channels } = getMe(state) || ({} as MemberModel);
  const allowed = channels ? channels.allowed : [];
  const active = channels ? channels.active : '';

  return CHANNELS.filter((channel: string) => allowed.includes(channel)).map(
    (channelName: string) => {
      return {
        name: channelName,
        displayName: channelName.charAt(0).toUpperCase() + channelName.slice(1),
        active: channelName === active,
      };
    },
  );
};

export const getIsDevChannels = (state: State): boolean => {
  const me = getMe(state);

  return !!(me && me.channels && me.channels.dev);
};

export const getTests = (state: State): TestModel[] => {
  const tests = window.abTests;
  const testNames = Object.keys(tests);

  return testNames
    .map((testName) => {
      const config = experiment.get(testName);

      return {
        name: testName,
        inExperiment: config.inExperiment,
        selectedVariation: config.get('variation') as string,
      };
    })
    .sort((testA, testB) => {
      const nameA = testA.name.toLowerCase();
      const nameB = testB.name.toLowerCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      return 0;
    });
};

export const getExperimentDetails = (
  experimentName: string,
): ExperimentDetailsObject => {
  const experimentAttrs = experiment.get(experimentName);
  const activeVariation = experimentAttrs.get('variation') as string;
  const config = window.abTests[experimentName];

  const variations: Variation[] = [
    {
      name: 'control',
      weight: config.defaultWeight,
    },
  ];

  config.variations.forEach((variation: Variation) =>
    variations.push({
      name: variation.name,
      weight: variation.weight,
    }),
  );

  const totalWeight = variations
    .map((variation) => variation.weight)
    .reduce((sum: number, v: number) => sum + v, 0);

  variations.forEach((entry) => {
    entry.active = entry.name === activeVariation;
    entry.percentage = Math.round((10000 * entry.weight) / totalWeight) / 100;

    return entry;
  });

  let foundAudience = false;
  const allocations = config.audiences.map((audience: AudienceName) => {
    // Simple Test uses the first audience that the member
    // is in
    const inAudience =
      experiment.audienceDefinitions[audience] &&
      (experiment.audienceDefinitions[audience] as AudienceCheck)(
        config.audienceSettings,
      );

    const used = !foundAudience && inAudience;
    foundAudience = foundAudience || inAudience;

    const allocation =
      config.experimentAllocation instanceof Object
        ? config.experimentAllocation[audience] || 0
        : config.experimentAllocation;

    return {
      audience,
      allocation,
      used,
    };
  });

  return {
    activeVariation,
    allocations,
    variations,
    meta: config.meta,
    audienceSettings: config.audienceSettings,
  };
};



// WEBPACK FOOTER //
// ./app/gamma/src/selectors/channels.ts